package com.wharpe.finsimweb

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

class SitePalette(
    val background: Color,
    val surface: Color,
    val surfaceVariant: Color,
    val onSurface: Color,
    val muted: Color,
    val outline: Color,
    val brand: Brand,
) {
    class Brand(
        val primary: Color,
        val primaryDark: Color,
        val primaryContainer: Color,
        val onPrimaryContainer: Color,
        val secondary: Color,
        val tertiary: Color,
        val gain: Color,
        val loss: Color,
    )
}

object SitePalettes {
    val light = SitePalette(
        background = Color.rgb(0xFAFAFC),
        surface = Color.rgb(0xFFFFFF),
        surfaceVariant = Color.rgb(0xF3F4F6),
        onSurface = Color.rgb(0x0F172A),
        muted = Color.rgb(0x64748B),
        outline = Color.rgb(0xE5E7EB),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x0F4FB8),
            primaryDark = Color.rgb(0x0A3B8A),
            primaryContainer = Color.rgb(0xDBEAFE),
            onPrimaryContainer = Color.rgb(0x0A2B5C),
            secondary = Color.rgb(0x10B981),
            tertiary = Color.rgb(0xF59E0B),
            gain = Color.rgb(0x10B981),
            loss = Color.rgb(0xEF4444),
        )
    )
    val dark = SitePalette(
        background = Color.rgb(0x0A0E1A),
        surface = Color.rgb(0x111827),
        surfaceVariant = Color.rgb(0x1F2937),
        onSurface = Color.rgb(0xF9FAFB),
        muted = Color.rgb(0x9CA3AF),
        outline = Color.rgb(0x1F2937),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x3B82F6),
            primaryDark = Color.rgb(0x2563EB),
            primaryContainer = Color.rgb(0x1E3A8A),
            onPrimaryContainer = Color.rgb(0xDBEAFE),
            secondary = Color.rgb(0x10B981),
            tertiary = Color.rgb(0xF59E0B),
            gain = Color.rgb(0x10B981),
            loss = Color.rgb(0xEF4444),
        )
    )
}

val BrandGradientStart = Color.rgb(0x0F4FB8)
val BrandGradientEnd = Color.rgb(0x1E3A8A)

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = SitePalettes.light.background
    ctx.theme.palettes.light.color = SitePalettes.light.onSurface
    ctx.theme.palettes.dark.background = SitePalettes.dark.background
    ctx.theme.palettes.dark.color = SitePalettes.dark.onSurface
}
